/* RESPONSIBLE TEAM: team-knowledge-foundations */
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';

export default class Category extends EmbercomBaseSerializer {
  attrs = {
    appId: { serialize: false },
    consentBannerSettingId: { serialize: false },
  };

  serialize(snapshot: any, options: any) {
    let json = super.serialize(snapshot, options);

    // Convert string ID to integer for backend compatibility
    if (json.id) {
      json.id = parseInt(json.id, 10);
    }

    return json;
  }
}
